import {
  NavioTireDimensionInput,
  type NavioTireDimensionInputProps
} from '@ui-components/Inputs/NavioTireDimensionInput';
import { useFieldContext } from '../formContext';
import { useTanstackFieldError } from '../useTanstackFieldAria';

type Props = Omit<NavioTireDimensionInputProps, 'value' | 'onChange' | 'onBlur' | 'name' | 'errorMessage'>;

/** `field.TireDimensionInput` — a tire size field holding `205/55R16`, with the field's error under the boxes. */
export const TanstackFormTireDimensionInput = (inputProps: Props) => {
  const field = useFieldContext<string>();
  const { errorMessage, shouldShow } = useTanstackFieldError(field);

  return (
    <NavioTireDimensionInput
      {...inputProps}
      name={field.name}
      value={field.state.value}
      errorMessage={shouldShow ? errorMessage : undefined}
      onBlur={field.handleBlur}
      onChange={field.handleChange}
    />
  );
};
